import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Alert from '@mui/material/Alert';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { useNotify } from './notify';

export default function EditFine({editedFineId, availableWorkers, setEditWindowOpen}) {
    const { notify, confirm } = useNotify();
    const [saveButtonDisable, setSaveButtonDisable] = useState(false);
    const [saveStatus, setSaveStatus] = useState("");
    const api_url = process.env.REACT_APP_API_URL;
    const complexName = localStorage.getItem('complex_name');
    const role = localStorage.getItem('role');
    const [fineId, setFineId] = useState("");
    const [fineAmount, setFineAmount] = useState("");
    const [complexName2, setComplexName2] = useState("");
    const [workerId, setWorkerId] = useState("");
    const [userId, setUserId] = useState("");
    const [recipientType, setRecipientType] = useState("worker");
    const [comment, setComment] = useState("");
    const [fineDate, setFineDate] = useState("");
    const [availableAdmins, setAvailableAdmins] = useState([]);

    useEffect(() => {
        async function getFineInfo() {
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
            body: JSON.stringify({ fine_id: editedFineId })
          };
          const fine = await (await fetch(api_url+"/api/fineInfo", requestOptions)).json();

          setFineId(fine.fine_id);
          setFineAmount(fine.fine_amount);
          setComplexName2(fine.complex_name);
          setRecipientType(fine.recipient_type || 'worker');
          setWorkerId(fine.worker_id || "");
          setUserId(fine.user_id || "");
          setComment(fine.comment);

          if (fine.fine_date) {
            const date = new Date(fine.fine_date);
            const formattedDate = date.toISOString().split('T')[0];
            setFineDate(formattedDate);
          }
        }

        async function getAvailableAdmins() {
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
              body: JSON.stringify({ complex_name: complexName })
            };
            const body = await (await fetch(api_url+"/api/availableAdmins", requestOptions)).json();
            setAvailableAdmins(body.map(({ user_id, fullname }) => ({ userId: user_id, fullName: fullname })));
        }

        getFineInfo();
        getAvailableAdmins();
    }, []);

    async function updateFineInfo() {
        setSaveButtonDisable(true);

        const requestBody = {
            fine_id: fineId,
            fine_amount: fineAmount,
            complex_name: complexName2,
            recipient_type: recipientType,
            comment: comment
        };

        if (recipientType === 'user') {
            const user_info = availableAdmins.find((s) => s.userId === userId);
            requestBody.user_id = userId;
            requestBody.user_name = user_info ? user_info.fullName : "";
        } else {
            const worker_info = availableWorkers.find((s) => s.workerId === workerId);
            requestBody.worker_id = workerId;
            requestBody.worker_name = worker_info ? worker_info.fullName : "";
        }

        if (role === "2" && fineDate) {
            requestBody.fine_date = fineDate;
        }

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
            body: JSON.stringify(requestBody)
        };

        const saving_fine = await fetch(api_url+"/api/updateFineInfo", requestOptions);

        const body = await saving_fine.json();
        if (body.message === "Fine info updated successfully!") {
          setSaveStatus("success");
        }
        else {
          setSaveStatus("error");
          setSaveButtonDisable(false);
        }
    }

    async function deleteFine() {
        const ok = await confirm({
            title: "Удалить штраф?",
            message: "Действие необратимо.",
            confirmText: "Удалить",
            destructive: true,
        });
        if (!ok) return;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
            body: JSON.stringify({ fine_id: fineId })
        };
        const response = await fetch(api_url + "/api/deleteFine", requestOptions);
        if (!response.ok) {
            notify("error", "Не удалось удалить штраф");
            return;
        }
        notify("success", "Штраф удалён");
        if (setEditWindowOpen) setEditWindowOpen(false);
    }

    return (
        <div className='edit-worker-modal'>
            <h1 className="modal-header"> Изменить информацию о штрафе </h1>
            <Box sx={{ maxWidth: 550, margin: `auto`, pt: 5, pb: 5 }}>

            <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel id="recipient-type-label">Тип получателя:</InputLabel>
            <Select
                value={recipientType}
                label="Тип получателя:"
                onChange={e => {
                    setRecipientType(e.target.value);
                    setWorkerId("");
                    setUserId("");
                }}
            >
                <MenuItem value="worker">Мойщик/Кассир/КК</MenuItem>
                <MenuItem value="user">Админ/HR-директор</MenuItem>
            </Select>
            </FormControl>

            <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel id="recipient-select-label">Сотрудник:</InputLabel>
            <Select
                value={recipientType === 'user' ? userId : workerId}
                label="Сотрудник:"
                fullWidth
                onChange={e => {
                    if (recipientType === 'user') {
                        setUserId(e.target.value);
                    } else {
                        setWorkerId(e.target.value);
                    }
                }}
            >
                {recipientType === 'user'
                    ? availableAdmins.map(({userId, fullName}) => (
                        <MenuItem key={userId} value={userId}> {fullName} </MenuItem>
                      ))
                    : availableWorkers.map(({workerId, fullName}) => (
                        <MenuItem key={workerId} value={workerId}> {fullName} </MenuItem>
                      ))
                }
            </Select>
            </FormControl>

            <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel htmlFor="component-outlined">Размер штрафа</InputLabel>
            <OutlinedInput
                label="Размер штрафа"
                name="fineAmount"
                value={fineAmount}
                onChange={e => setFineAmount(e.target.value)}
            />
            </FormControl>

            <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel htmlFor="component-outlined">Комментарий</InputLabel>
            <OutlinedInput
                label="Комментарий"
                name="comment"
                value={comment}
                onChange={e => setComment(e.target.value)}
            />
            </FormControl>

            {role === "2" && (
            <TextField
                sx={{mb:1.5, mt:1.5}}
                fullWidth
                label="Дата выставления штрафа"
                type="date"
                value={fineDate}
                onChange={(e) => setFineDate(e.target.value)}
                InputLabelProps={{
                    shrink: true,
                }}
            />
            )}

            <Button variant="contained"
                sx={{mb:1.5, mt:1.5}} fullWidth
                disabled={saveButtonDisable}
                color="success"
                className="mr10"
                onClick={() => updateFineInfo()}>Сохранить изменения</Button>

            {role === "2" && (
            <Button variant="outlined"
                sx={{mb:1.5}} fullWidth
                color="error"
                onClick={() => deleteFine()}>Удалить штраф</Button>
            )}

    {saveStatus === "error" && <Alert severity="error">Ошибка, проверьте правильность введенных данных!</Alert>}
    {saveStatus === "success" && <Alert severity="success">Изменения успешно сохранены!</Alert>}
    </Box>
        </div>
    );
}
